<div  style="width: 100%; text-align: center;" >
    <div


class="contentContainer" style="margin-top: 100px;">


    <DIV class="appLabel" >Click "Block Card" to proceed and block the card. </DIV>
    <DIV class="appLabel" >This will invalidate your current card and you will  </DIV>
    <DIV class="appLabel" >be logged out  </DIV>
    <div class="appButtonBar">
    <input type="submit"  class="appButton" name="cmdSubmit" id="cmdSubmit" style="width: 100px;" (click)="onBlockCard()" value="Block Card">
    <div style="width: 50px; clear: none; display: inline-block;"></div>
    <input type="submit"  class="appButton" name="cmdSubmit" id="cmdSubmit" style="width: 100px;" (click)="onCancel()" value="Cancel">
    </div>
    <div class="appLabel" style="color: red;">{{errMessage}}</div>

</div>
</div>